<template>
    <div class="phone-body">
        <div class="container">
            <img src="../../assets/img/Notica-logo.png" alt="Notica Logo">
            <p>برای ورود به نوتیکا لطفا شماره همراه<br> 
                خود را وارد کنید</p>
        </div>
        <div>
            <form class="phone-form" @submit.prevent="checkPhone">
                <input dir="ltr" class="phone-input" type="text" v-model="phone" placeholder="0912xxxxxxx" name="phone" id="phone" required pattern="[0-9]{11}" title="شماره همراه باید 11 رقم باشد" maxlength="11"> 
                <input type="submit" name="submit" id="submit" class="phone-btn" value="ثبت">
            </form>
        </div>
        <div class="overlay" v-if="loading">
            <div class="loader">
                <div class="circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            phone: '',
            loading: false
        };
    },
    mounted() {
    },
    methods: {
        async checkPhone() {
            if (/^\d{11}$/.test(this.phone)) {
                this.loading = true;
                try {
                    let response = await axios.post('https://api.noticapp.ir/v1/auth/check-phone', {
                        headers: {
                            accept: 'application/json',
                            contentType: 'application/json',
                        },
                        phone: this.phone,
                    });

                    if (response.data.status === 'error') {
                        alert(response.data.message);
                    } else {
                        this.$emit('nextPage', 'verify')
                        this.$emit('phone', this.phone);
                    }
                } catch (error) {
                    if (error.response) {
                        alert(error.response.data.message);
                    } else {
                        console.error('خطای ناشناخنه رخ داده است: ', error);
                    }
                } finally {
                    this.loading = false;
                }
            } else {
                alert("شماره همراه باید 11 رقم باشد.");
            }
        }
    }
}
</script>

<style scoped>
    .phone-body {
        background-color: #25292E;
        height: 100vh;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 25px;
    }
    img {
        width: 215px;
        height: 200px;
    }
    p {
        font-size: 22px;
        color: #fff;
    }

    .phone-form {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .phone-input {
        border: none;
        border-radius: 20px;
        padding: 15px;
        font-size: 22px;
        width: 300px;
        height: 50px;
        transition: all 0.3s;
        text-align: center;
        align-self: center;
        display: flex;
        justify-content: center;
        align-items: center;
        
    }

    .phone-input:focus {
        border: none;
        outline: none;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        
    }
    .phone-btn {
        background-color: #028D92;
        color: white;
        border: none;
        border-radius: 20px;
        font-size: 22px;
        cursor: pointer;
        width: 175px;
        height: 40px;
        align-self: center;
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8); /* پس‌زمینه نیمه‌شفاف */
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(5px); /* افکت مات */
        z-index: 1000; /* بالاتر از همه عناصر */
    }

    .loader {
        background: transparent;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .circle {
    width: 80px;
    height: 80px;
    border: 3px solid #028d92;
    position: absolute;
    border-radius: 50%;
    animation: circle14512 1.5s linear infinite;
    }

    .circle::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #cc0066;
    box-shadow: 0 0 10px #cc0066, 0 0 20px #cc0066;
    }

    @keyframes circle14512 {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>